module.exports = __webpack_public_path__ + "img/4.d972b696.svg";